import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const Status = () => {
  return(
    <SettingsMetaData propertyName={"RequestStatus"} viewPropertyName={"Request Status"} />
  )
};

export default Status;
